import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import InsuranceTable from "./insuranceTable"

const InusranceTableContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
          <InsuranceTable />
        </>
      </div>
    </div>
  )
}

export default InusranceTableContainer